module.exports = __webpack_public_path__ + "images/emoji/clock6.e4e9f0e8e6e2714f4e6a.png";